function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { j as o } from "./index.es33.js";
import { clsx as i } from "./index.es105.js";
import { Typography as F } from "./index.es35.js";
import { palette as n } from "./index.es36.js";
import { Icon as p } from "./index.es7.js";
import { inputSelectors as B } from "./index.es107.js";
import { SearchKind as y } from "./index.es114.js";
import { useSearchState as I } from "./index.es115.js";
import e from "./index.es116.js";
import a from "./index.es111.js";

var b = 20,
    z = function z(_ref) {
  var _i, _i2, _i3;

  var S = _ref.isClearable,
      t = _ref.isDisabled,
      l = _ref.onChange,
      f = _ref.placeholder,
      r = _ref.value,
      c = _ref.isError,
      _ref$kind = _ref.kind,
      x = _ref$kind === void 0 ? y.outline : _ref$kind,
      g = _ref.isLarge,
      j = _ref.maxLength,
      m = _ref.width;

  var _I = I({
    onChange: l,
    placeholder: f,
    kind: x
  }),
      w = _I.handleClear,
      s = _I.isSimpleKind,
      u = _I.searchPlaceholder,
      h = _I.isFocused,
      d = _I.setIsFocused;

  return o.jsx("label", {
    className: i(a.container, (_i = {}, _defineProperty(_i, a.containerWithError, c && !t), _defineProperty(_i, a.containerDisabled, t), _i)),
    children: o.jsxs("div", {
      className: i(e.wrapper, a.wrapper, B.classNames.wrapper, (_i2 = {}, _defineProperty(_i2, e.wrapperSimple, s), _defineProperty(_i2, e.wrapperFilled, !!r || c || h), _defineProperty(_i2, e.wrapperFocused, h), _defineProperty(_i2, e.wrapperWithError, c), _defineProperty(_i2, e.wrapperDisabled, t), _i2)),
      children: [o.jsx(p, {
        icon: p.icons.system.s.utilities.loupe,
        size: 16,
        color: r ? n.gray10 : n.gray6,
        className: e.iconSearch
      }), o.jsx(F.Body2, {
        className: i(a.input, e.input, (_i3 = {}, _defineProperty(_i3, e.inputSimple, s), _defineProperty(_i3, e.inputLarge, g && !s), _i3)),
        style: {
          width: m ? "".concat(m, "px") : "auto"
        },
        as: "input",
        disabled: t,
        type: "search",
        value: r,
        maxLength: j,
        placeholder: u,
        onChange: function onChange(N) {
          return l === null || l === void 0 ? void 0 : l(N.target.value);
        },
        onFocus: function onFocus() {
          return d(!0);
        },
        onBlur: function onBlur() {
          return d(!1);
        },
        size: s ? r ? r.length : u.length : b
      }), !t && S && r && o.jsx("button", {
        className: i(e.clearBtn, _defineProperty({}, e.clearBtnSimple, s)),
        type: "button",
        onClick: w,
        children: o.jsx(p, {
          icon: p.icons.system.s.utilities.cross,
          size: 16,
          color: n.gray6,
          className: "icon--clear"
        })
      })]
    })
  });
};

z.kind = y;
export { z as Search };